export const isShaanBanner = (title?: string): boolean => {
  if (!title) return false
  const upper = title.toUpperCase()
  return (
    upper.includes('SHAAN CONCERT IN CHARLOTTE') ||
    (upper.includes('SHAAN') && upper.includes('CHARLOTTE')) ||
    upper.includes('SHAAN')
  )
}

export const openShaanBridgePage = () => {
  const baseUrl = import.meta.env.BASE_URL.endsWith('/')
    ? import.meta.env.BASE_URL
    : `${import.meta.env.BASE_URL}/`
  const targetUrl = `${baseUrl}shaan-charlotte.html`
  window.open(targetUrl, '_blank', 'noopener,noreferrer')
}
